module.exports = __webpack_public_path__ + "static/media/CANIMOLT_BannerCompendio_web.7a5a492c.jpg";